import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import noop from 'lodash/noop';
import { ProfileSettingsConfig } from '@Constants/rx-user/constants';
import ProfileSettingsAccordionItem from '@Pages/ProfileSettings/Components/ProfileSettingsAccordionItem';

import './TextContrast.theme.scss';

function TextContrast({ currentOption, options, onChange, onSave, onClose }) {
  return (
    <ProfileSettingsAccordionItem
      onClose={onClose}
      onSave={onSave}
      label={ProfileSettingsConfig.Labels.contrast}
      value={<span className={`preferences-text-value text-contrast-preview text-contrast text-contrast-${currentOption}`} />}
      title={ProfileSettingsConfig.Labels.contrast}
      notTagged
      titled
      validateOnSave
      className="text-contrast-accordion-item">
      <div className="text-contrast-accordion-item__wrapper">
        {options.map((option) => (
          // eslint-disable-next-line jsx-a11y/click-events-have-key-events,jsx-a11y/no-static-element-interactions
          <span
            key={`text-contrast-${option.value}`}
            className={cn(`preferences-text-value text-contrast text-contrast-${option.value}`, currentOption === option.value && 'active')}
            onClick={() => onChange('RX2_PAGE_STYLE_TEXT_CONTRAST', option.value)}
          />
        ))}
      </div>
    </ProfileSettingsAccordionItem>
  );
}

TextContrast.propTypes = {
  currentOption: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  options: PropTypes.array,
  onChange: PropTypes.func,
  onSave: PropTypes.func,
  onClose: PropTypes.func,
};

TextContrast.defaultProps = {
  options: [],
  onChange: noop,
  onSave: noop,
  onClose: noop,
};

export default TextContrast;
